import { Noto_Sans } from 'next/font/google';

// More info about the display property:
// @link https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display#values

const NotoSans = Noto_Sans({
    weight: ['300', '400', '600', '700'],
    subsets: ['latin', 'latin-ext'],
    display: 'swap',
});

export { NotoSans };

const fonts = {
    header: NotoSans.style.fontFamily,
    button: NotoSans.style.fontFamily,
    body: NotoSans.style.fontFamily,
    body2: NotoSans.style.fontFamily,
    notoSans: NotoSans.style.fontFamily,
} as const;

export default fonts;
